export enum MetadataType {
    String = 0,
    Datetime = 1,
    Enum = 2,    
}